import styled from 'styled-components';

export const AnimatedContainer = styled.div`
  @keyframes slideIn {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideUp {
    0% {
      transform: translateY(20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes footerEnter {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .animate-slideIn {
    animation: slideIn 0.8s ease-out forwards;
  }

  .animate-slideUp {
    animation: slideUp 0.8s ease-out forwards;
  }

  .animate-footerEnter {
    animation: footerEnter 1s ease-out forwards;
  }

  .animate-delay-300 {
    animation-delay: 0.3s;
  }

  .animate-delay-600 {
    animation-delay: 0.6s;
  }

  @media screen and (max-width: 767px) {
    .hero-parent {
      background-image: none !important;
    }
  }
`;
